/**
 * @TODO CB-20304
 * Adding button styling
 * No secondary overrides necessary
 * Not in the theme:
 *   Roboto Condensed
 */

/* istanbul ignore next */
const styles = ({ button = { tertiary: {}, borderRadius: 30 }, typography = {} }) => ({
  borderRadius: button.borderRadius,
  fontFamily: 'Roboto Condensed',
  primary: {
    fontWeight: typography.fontWeightHeavy,
    textTransform: 'uppercase'
  },
  secondary: {
    textTransform: 'uppercase'
  },
  tertiary: {
    backgroundColor: 'transparent',
    color: button.tertiary.textColor,
    textDecoration: button.tertiary.textDecoration,
    '&.btn:hover': {
      color: button.tertiary.hoverColor,
      textDecoration: button.tertiary.hoverTextDecoration,
      background: 'transparent'
    }
  },
  small: {
    borderRadius: button.borderRadius
  },
  extraSmall: {
    borderRadius: button.borderRadius
  }
});

export default styles;
